<div class="address">{{ 'organization.address' | translate }}: {{address()}}</div>
<div class="map-container">
  <google-map
    height="500px"
    width="100%"
    [center]="center()"
    [zoom]="zoom()"
    [options]="mapOptions"
    (mapClick)="onMapClick($event)">

    @if (markerPosition()) {
      <map-marker [position]="markerPosition()"></map-marker>
    }
  </google-map>

  <input #addressInput class="control" type="text" [placeholder]="'event.search_box' | translate">
</div>
